import GuestRoutes from "./routes/guestRoutes";
function App() {
  return (
    <>
      <GuestRoutes />
    </>
  );
}

export default App;
